'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLastAck = exports.generateItems = undefined;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _v = require('uuid/v4');

var _v2 = _interopRequireDefault(_v);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var generateItems = function generateItems() {
  var profile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var items = {};
  if (profile === null) {
    return items;
  }

  (profile.itemTypes || []).forEach(function (val) {
    _lodash2.default.times(val.quantity).forEach(function () {
      var id = (0, _v2.default)();
      items[id] = {
        id: id,
        type: val.type
      };
    });
  });

  console.log('items', items);

  return items;
};

var getLastAck = function getLastAck() {
  var acknowledgements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return _lodash2.default.values(acknowledgements).reduce(function (res, ack) {
    if (!res) {
      return ack;
    }

    if ((0, _moment2.default)(ack.at).isAfter((0, _moment2.default)(res.at))) {
      return ack;
    }

    return res;
  }, null);
};

exports.generateItems = generateItems;
exports.getLastAck = getLastAck;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@sakari-io/staza-common/dist/tasks.js
// module id = 1150
// module chunks = 0